import axios from 'axios';

export interface InboxFiltersObject {
  locationIds: number[];
  salesRepIds: string[];
  phoneNumbers: string[];
  assignedUserIds: string[];
  isRead?: boolean;
}

class InboxFiltersService {
  public defaultInboxFiltersObject: InboxFiltersObject = {
    locationIds: [],
    salesRepIds: [],
    phoneNumbers: [],
    assignedUserIds: [],
  };

  async deleteFilters(engageOrigin: string, accessToken: string) {
    try {
      await axios.delete(`${engageOrigin}/api/v1/user/conversations/filters`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      return 'success';
    } catch (error) {
      return error;
    }
  }

  async saveFilters(
    engageOrigin: string,
    accessToken: string,
    filtersObject: InboxFiltersObject
  ) {
    try {
      const response = await axios.post(
        `${engageOrigin}/api/v1/user/conversations/filters`,
        { filters: JSON.stringify(filtersObject) },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      return !!response.data.success;
    } catch (error) {
      return false;
    }
  }

  async getCurrentFilters(engageOrigin: string, accessToken: string) {
    try {
      const response = await axios.get(
        `${engageOrigin}/api/v1/user/conversations/filters`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (!response.data || !response.data.success) {
        return this.defaultInboxFiltersObject;
      }

      const responseData = response.data;
      const filters = JSON.parse(responseData.filters) as InboxFiltersObject;

      if (!Object.keys(filters).length) {
        return this.defaultInboxFiltersObject;
      }

      return filters;
    } catch (error) {
      console.log('Error fetching filters: ', error);
      return this.defaultInboxFiltersObject;
    }
  }
}

export const inboxFiltersService = new InboxFiltersService();
